// Browser entry check only, not server authorization.
(function () {
  var match = window.location.pathname.match(
    /\/products\/([a-z]-\d+)-p-/
  );

  var productOrg = match ? match[1] : null;
  var urlOrg = new URLSearchParams(
    window.location.search
  ).get('org');

  var storedOrg = null;

  try {
    storedOrg = sessionStorage.getItem('org_code');
  } catch (error) {
    // Return to member login if browser storage is unavailable.
  }

  if (!productOrg ||
      urlOrg !== productOrg ||
      storedOrg !== productOrg) {
    window.location.replace('/pages/org-login');
  }
})();


document.addEventListener('DOMContentLoaded', function() {
  const path = window.location.pathname;
  const match = path.match(/\/(s-\d+)-s-/);
  if (!match) return;

  const orgCode = match[1];
  const backUrl = `/pages/org-shop?org=${orgCode}`;

  const backBtn = document.createElement('div');
  backBtn.style.cssText = 'width:100%; padding:12px 16px; background:#fff;';
  backBtn.innerHTML = `
    <a href="${backUrl}" style="
      display:inline-flex; align-items:center; gap:8px;
      background:#6B3A2A; color:white; padding:10px 22px;
      border-radius:25px; font-weight:bold; font-size:15px;
      text-decoration:none; box-shadow:2px 2px 6px rgba(0,0,0,0.2);
    ">← Back</a>`;

  const main = document.querySelector('#MainContent');
  if (main) {
    main.insertBefore(backBtn, main.firstChild);
  } else {
    document.body.prepend(backBtn);
  }
});
